<template>
  <v-btn-toggle
    v-if="dishOrders.length > 1"
    v-model="value"
    mandatory
    rounded
    borderless
    color="primary"
    class="ma-1"
  >
    <v-btn
      v-for="dishOrder in dishOrders"
      :key="dishOrder.id"
      :small="! xsmall"
      :x-small="xsmall"
      height="32"
      :value="dishOrder.order"
    >
      <span v-if="xxsmall">
        {{ dishOrder.name | justTheFirst }}
      </span>
      <span v-else>
        {{ dishOrder.name | justTheTwoOfYou }}
      </span>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
  export default {
    computed: {
      value: {
        get () {
          return this.$store.state.orders.dishOrder
        },
        set (v) {
          this.$store.commit('orders/dishOrder', v)
        },
      },
      dishOrders () {
        return this.$store.getters['catalog/activeDishOrders']
      },
      xsmall () {
        return this.dishOrders.length > 7
      },
      xxsmall () {
        return this.dishOrders.length > 9
      },
    },

    filters: {
      justTheTwoOfYou: v => v.substr(0, 2),
      justTheFirst: v => v[0],
    },
  }
</script>
